import { Button, Flex, HStack, Icon, Text } from '@chakra-ui/react';
import {
  TrackArticle,
  TrackAssessment,
  TrackFile,
  TrackImportedContent,
  TrackScorm,
  TrackVideo,
} from '@/client/components/icons/ContinuIcons';

import type { AssignmentFormData } from '../../../types/assignmentTypes';
import { WorkflowObjectType } from '@/client/services/api/graphql/gql/graphql';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface TriggerObjectBannerProps {
  onOpen: () => void;
}

export default function TriggerObjectBanner({ onOpen }: TriggerObjectBannerProps) {
  const { t } = useTranslation();
  const { watch } = useFormContext<AssignmentFormData>();
  const { settings } = watch();
  const { triggerObject, objectType } = settings;

  const objectTypeIconMap: Record<WorkflowObjectType, React.ElementType> = {
    [WorkflowObjectType.Article]: TrackArticle,
    [WorkflowObjectType.Assessment]: TrackAssessment,
    [WorkflowObjectType.File]: TrackFile,
    [WorkflowObjectType.Scorm]: TrackScorm,
    [WorkflowObjectType.Video]: TrackVideo,
    [WorkflowObjectType.Track]: TrackArticle,
    [WorkflowObjectType.Journey]: TrackArticle,
    [WorkflowObjectType.ImportedContent]: TrackImportedContent,
    [WorkflowObjectType.Event]: TrackArticle,
    [WorkflowObjectType.Poll]: TrackArticle,
    [WorkflowObjectType.Presentation]: TrackArticle,
    [WorkflowObjectType.Quiz]: TrackArticle,
    [WorkflowObjectType.User]: TrackArticle,
    [WorkflowObjectType.Workshop]: TrackArticle,
  };

  return (
    <Flex
      marginBottom={6}
      backgroundColor="warmNeutral.0"
      padding={4}
      paddingY={3}
      paddingX={4}
      border="1px solid"
      borderColor="warmNeutral.700"
      borderRadius="6px"
      justifyContent="space-between"
      alignItems="center"
    >
      <HStack>
        {objectType && <Icon as={objectTypeIconMap[objectType]} boxSize={6} />}

        <Text fontSize="14px" fontWeight={500} color="baseBlack">
          {triggerObject?.title}
        </Text>
      </HStack>

      <Button
        border="1px solid"
        borderColor="warmNeutral.200"
        borderRadius="8px"
        backgroundColor="white"
        fontSize="12px"
        fontWeight={600}
        paddingX={3}
        paddingY={2}
        color="baseBlack"
        _hover={{
          cursor: 'pointer',
          backgroundColor: 'warmNeutral.100',
        }}
        onClick={onOpen}
      >
        {t('admin.assignments.automations.triggerObject.change')}
      </Button>
    </Flex>
  );
}
